import type { FC, ReactNode } from "react";
import { NEUTRAL } from "@/theme/tokens";
import { EyebrowLabel } from "../molecules/EyebrowLabel";

type Props = {
	/** Already translated — "On this shift", "Other units", a list's count. */
	children: ReactNode;
	dataTestId?: string;
};

/**
 * A small uppercase label over a run of rows inside a `SheetStep` — "On this shift", "Other units". The house eyebrow
 * (`EyebrowLabel`) set in a quiet full-width band at the rows' inset, so a long list reads as groups rather than one
 * undifferentiated column.
 */
export const SheetStepSectionLabel: FC<Props> = ({ children, dataTestId }) => (
	<EyebrowLabel component="h3" dataTestId={dataTestId} sx={{ m: 0, px: 2, pt: 1.75, pb: 0.75, bgcolor: NEUTRAL[50] }}>
		{children}
	</EyebrowLabel>
);
